/* Zelura — interacciones propias. Sin librerias externas. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Animacion de entrada compartida por toda la web */
  function initReveal() {
    var items = document.querySelectorAll('.zl-reveal');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) items[i].classList.add('zl-visible');
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var d = parseInt(el.getAttribute('data-zl-retraso') || '0', 10);
        setTimeout(function () { el.classList.add('zl-visible'); }, d);
        obs.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    for (var j = 0; j < items.length; j++) obs.observe(items[j]);
  }

  /* Cifras que cuentan hacia arriba al entrar en pantalla */
  function initCifras() {
    var nums = document.querySelectorAll('[data-zl-contador]');
    if (!nums.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < nums.length; i++) nums[i].textContent = nums[i].getAttribute('data-zl-contador');
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        obs.unobserve(el);
        var destino = parseFloat(el.getAttribute('data-zl-contador'));
        var dec = (el.getAttribute('data-zl-contador').split('.')[1] || '').length;
        if (isNaN(destino)) return;
        var ini = null;
        var dur = 1400;
        function paso(t) {
          if (ini === null) ini = t;
          var p = Math.min((t - ini) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (destino * eased).toFixed(dec);
          if (p < 1) requestAnimationFrame(paso);
          else el.textContent = destino.toFixed(dec);
        }
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.5 });
    for (var j = 0; j < nums.length; j++) obs.observe(nums[j]);
  }

  /* Preguntas frecuentes desplegables */
  function initFaq() {
    var btns = document.querySelectorAll('.zl-faq__btn');
    if (!btns.length) return;
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function () {
        var item = this.closest('.zl-faq__item');
        var panel = item.querySelector('.zl-faq__panel');
        var abierto = item.classList.contains('zl-abierto');
        var hermanos = item.parentNode.querySelectorAll('.zl-faq__item.zl-abierto');
        for (var k = 0; k < hermanos.length; k++) {
          hermanos[k].classList.remove('zl-abierto');
          hermanos[k].querySelector('.zl-faq__panel').style.height = '0px';
          hermanos[k].querySelector('.zl-faq__btn').setAttribute('aria-expanded', 'false');
        }
        if (!abierto) {
          item.classList.add('zl-abierto');
          panel.style.height = panel.firstElementChild.offsetHeight + 'px';
          this.setAttribute('aria-expanded', 'true');
        }
      });
    }
  }

  /* Galeria deslizable de la pagina de producto */
  function initGaleria() {
    var wrap = document.querySelector('[data-zl-galeria]');
    if (!wrap) return;
    var pista = wrap.querySelector('[data-zl-pista]');
    if (!pista) return;
    var slides = pista.querySelectorAll('[data-zl-slide]');
    if (slides.length < 2) return;

    var anterior = wrap.querySelector('[data-zl-anterior]');
    var siguiente = wrap.querySelector('[data-zl-siguiente]');
    var contador = wrap.querySelector('[data-zl-contador-gal]');
    var minis = wrap.querySelectorAll('[data-zl-ir]');
    var actual = 0;

    function irA(i) {
      actual = Math.max(0, Math.min(slides.length - 1, i));
      pista.scrollTo({ left: slides[actual].offsetLeft - pista.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      pintar();
    }

    function pintar() {
      if (contador) contador.textContent = actual + 1 + ' / ' + slides.length;
      for (var k = 0; k < minis.length; k++) {
        minis[k].classList.toggle('zl-activa', k === actual);
      }
      if (anterior) anterior.disabled = actual === 0;
      if (siguiente) siguiente.disabled = actual === slides.length - 1;
    }

    if (anterior) anterior.addEventListener('click', function () { irA(actual - 1); });
    if (siguiente) siguiente.addEventListener('click', function () { irA(actual + 1); });
    for (var k = 0; k < minis.length; k++) {
      minis[k].addEventListener('click', function () {
        irA(parseInt(this.getAttribute('data-zl-ir'), 10));
      });
    }

    /* Al arrastrar con el dedo, seguimos en que foto esta */
    var t = null;
    pista.addEventListener('scroll', function () {
      if (t) clearTimeout(t);
      t = setTimeout(function () {
        var centro = pista.scrollLeft + pista.clientWidth / 2;
        for (var i = 0; i < slides.length; i++) {
          var izq = slides[i].offsetLeft - pista.offsetLeft;
          if (centro >= izq && centro < izq + slides[i].offsetWidth) {
            if (actual !== i) { actual = i; pintar(); }
            break;
          }
        }
      }, 90);
    }, { passive: true });

    /* Flechas del teclado */
    pista.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); irA(actual + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); irA(actual - 1); }
    });

    pintar();
  }

  /* Barra fija de compra: aparece al pasar el boton principal */
  function initSticky() {
    var barra = document.querySelector('[data-zl-sticky]');
    if (!barra) return;
    var disparador = document.querySelector('[data-zl-disparador]');
    if (!disparador || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        barra.classList.toggle('zl-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    obs.observe(disparador);
  }

  /* Marquesinas: duplica el contenido para que el bucle no tenga cortes */
  function initMarquesinas() {
    var pistas = document.querySelectorAll('[data-zl-bucle]');
    for (var i = 0; i < pistas.length; i++) {
      var pista = pistas[i];
      if (pista.getAttribute('data-zl-listo')) continue;
      var grupo = pista.firstElementChild;
      if (!grupo) continue;
      pista.appendChild(grupo.cloneNode(true));
      pista.setAttribute('data-zl-listo', '1');
    }
  }

  function init() {
    initReveal();
    initCifras();
    initFaq();
    initGaleria();
    initSticky();
    initMarquesinas();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* El editor de Shopify recarga secciones sueltas: reiniciamos lo necesario */
  document.addEventListener('shopify:section:load', init);
})();
